import VideoAnalytics from "./VideoAnalytics";
import { Navigate, Route, Routes } from "react-router";

const AnalyticsRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<Navigate to={"/analytics/videos"} />} />
      <Route path="videos" element={<VideoAnalytics />} />

      <Route path=":category/:id" element={<VideoAnalytics />} />
    </Routes>
  );
};

export default AnalyticsRoutes;
